import React, { ReactNode } from "react";
import { Modal } from "react-bootstrap";

interface ModalProps {
  size?: "xl" | "lg" | "sm"
  show: boolean;
  onClose: () => void;
  title: string;
  children?: ReactNode;
}

const PortalModal: React.FC<ModalProps> = ({
  size = "lg",
  show,
  onClose,
  title = "Modal Title",
  children
}) => (
  <Modal show={show} onHide={onClose} size={size} backdrop="static" keyboard={false} centered>
    <Modal.Header closeButton>
      <Modal.Title>{title}</Modal.Title>
    </Modal.Header>

    <Modal.Body>{children}</Modal.Body>
  </Modal>
);


export default PortalModal;
